<template>
  <transition name="fade">
    <p v-text="text"></p>
  </transition>
</template>
<script>
export default {
  name: 'AnimationLabel',
  props: {
    text: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="stylus" scoped>
.transform-moving
  &__focus
    cursor
.fade-enter-active, .fade-leave-active
        transition: opacity .2s

.fade-enter, .fade-leave-to
        opacity: 0
</style>
